export default __webpack_public_path__ + "static/media/headerlogo.632630bf.svg";